import { Typography } from '@smartgift/frontend-toolkit';
import React, { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

import { ShareLink, ShareTable } from '@hero/components/organisms/Share';
import { useGetRecognition, useGetRecognitionOrders } from '@hero/services';

import * as S from './style';

export function SendGiftWithContactTable() {
  const { t } = useTranslation();

  const { recognitionCode } = useParams();

  const [globalFilters, setGlobalFilters] = useState({});
  const [{ pageIndex, pageSize }, setPagination] = useState({
    pageIndex: 0,
    pageSize: 10
  });
  const { data: recognition } = useGetRecognition({ recognitionCode });
  const secureSingleLink = recognition?.link?.shortened;
  const featureType = 'recognition';

  const params = useMemo(
    () => ({
      filters: {
        searchTerm: globalFilters?.searchTerms,
        giftStatus: globalFilters?.filters?.map(filter => filter.value),
        recognitionId: recognition?.id
      },
      pagination: {
        limit: pageSize,
        page: pageIndex + 1
      }
    }),
    [pageSize, pageIndex, recognition?.id, globalFilters]
  );

  const {
    data: recipientsData,
    isFetching: isLoadingRecipients,
    refetch: refetchRecipients
  } = useGetRecognitionOrders(params, {
    retryOnMount: false,
    enabled: !!recognition?.id
  });

  return (
    <S.Wrapper>
      <S.Head>
        <S.HeadTitleArea>
          <Typography variant="subtitle4SemiBold">{t('oneLinkForEasySharing')}</Typography>
          <Typography emphasis="weak">{t('oneLinkForEasySharingDesc')}</Typography>
        </S.HeadTitleArea>
        <ShareLink
          position="left-start"
          secureSingleLink={secureSingleLink}
          featureType={featureType}
          shareButtonVariant="contained"
        />
      </S.Head>

      <S.Content>
        <S.ContentHeadArea>
          <Typography variant="subtitle4SemiBold">{t('uniqueLinkForEveryRecipient')}</Typography>
          <Typography emphasis="weak">{t('sendTailoredLinkToEachRecipientDesc')}</Typography>
        </S.ContentHeadArea>
        <ShareTable
          data={recipientsData?.docs}
          globalFilters={globalFilters}
          setGlobalFilters={setGlobalFilters}
          pagination={{
            pageIndex,
            pageSize,
            total: recipientsData?.totalDocs
          }}
          isLoading={isLoadingRecipients}
          pageCount={recipientsData?.totalPages}
          setPagination={setPagination}
          refetchRecognition={refetchRecipients}
        />
      </S.Content>
    </S.Wrapper>
  );
}
